// extracted by mini-css-extract-plugin
export default {"search":"ProductSearch_search__6MdyL"};